import { getData, postData } from '../';
import URL from '../../utils/baseUrls';
import { PayloadTypes } from '../types';

/**
 * get the Plan details form the backend
 * @returns
 */
export const getPlanData = async () => {
    const res = await getData(URL.getPaymentPlansUrl());
    return res;
};

/**
 * post the Subsciption details to the backend
 * @param payload An object contain subscription data
 * @param nodeType Type of the node
 * @returns
 */
export const createSubscription = async (payload: PayloadTypes.CreateSubscriptionPayload, nodeType: string) => {
    const res = await postData(URL.getSubscriptionUrl(nodeType), payload);
    return res;
};

/**
 * To delete a node
 * @param networkId
 * @param nodeId
 * @returns
 */
export const deleteNode = async (networkId: string | number, nodeId: string) => {
    const res = await getData(URL.deleteNodeById(networkId, nodeId));
    return res;
};

/**
 * get the RPC details form the backend
 * @param networkId
 * @param id
 * @returns
 */
export const getRpcDetails = async (networkId: string, id: string) => {
    const res = await getData(URL.getRpcDetails(networkId, id));
    return res;
};

export const addNode = async (payload: PayloadTypes.AddNodePayload, networkId: string) => {
    const res = await postData(URL.addNode(networkId), payload);
    return res;
};

export const addStakingNode = async (payload: PayloadTypes.AddStakingNodePayload, networkId: string) => {
    const res = await postData(URL.addNode(networkId), payload);
    return res;
};
